import { useTranslation } from "react-i18next";

import {
  Container,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  StepContent,
  StepContentProps,
} from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2/Grid2";
import ShortTextIcon from "@mui/icons-material/ShortText";

import { FireworksIcon, PillIcon, TargetIcon } from "@robin/common";

import { Datapoint } from "../hooks/useVisualisationData";
import { PatientData } from "../models/patient-data";

export const TimelineItemDetails: React.FC<
  StepContentProps & {
    data: Datapoint;
    references?: Pick<PatientData["data"], "medicaments" | "weeklyTargets">;
  }
> = ({ data, references, ...rootProps }) => {
  const { t } = useTranslation();
  const { medicaments, weeklyTargets } = references || {};
  return (
    <StepContent {...rootProps}>
      <Grid
        alignContent="center"
        alignItems="center"
        container
        spacing={{ xs: 1, md: 2 }}
      >
        <Grid xs={8} xsOffset={2}>
          <Container
            disableGutters
            maxWidth="sm"
            sx={{ mt: 1, px: { xs: 0.5, md: 1 } }}
          >
            <List dense disablePadding>
              {data.extras.experiences?.map((experience) => (
                <ListItem disableGutters key={experience.id}>
                  <ListItemIcon>
                    <FireworksIcon
                      fontSize="small"
                      sx={{ color: "text.disabled" }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={experience.title}
                    primaryTypographyProps={{
                      color: "text.disabled",
                      variant: "caption",
                    }}
                    secondary={experience.description}
                    secondaryTypographyProps={{ variant: "caption" }}
                  />
                </ListItem>
              ))}
              {data.extras.medicamentLogs?.map((medicamentLog) => (
                <ListItem disableGutters key={medicamentLog.id}>
                  <ListItemIcon>
                    <PillIcon
                      fontSize="small"
                      sx={{ color: "text.disabled" }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      medicaments?.find(
                        (o) => o.id === medicamentLog.medicamentId,
                      )?.name || t("tabs.timeline.medicament-name-missing")
                    }
                    primaryTypographyProps={{
                      color: "text.disabled",
                      variant: "caption",
                    }}
                    // secondary={medicamentLog.description}
                    // secondaryTypographyProps={{ variant: "caption" }}
                  />
                </ListItem>
              ))}
              {data.extras.notes?.map((note) => (
                <ListItem disableGutters key={note.id}>
                  <ListItemIcon>
                    <ShortTextIcon
                      fontSize="small"
                      sx={{ color: "text.disabled" }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={note.note}
                    primaryTypographyProps={{
                      color: "text.disabled",
                      variant: "caption",
                    }}
                  />
                </ListItem>
              ))}
              {data.extras.weeklyTargetLogs?.map((targetLog) => (
                <ListItem disableGutters key={targetLog.id}>
                  <ListItemIcon>
                    <TargetIcon
                      fontSize="small"
                      sx={{ color: "text.disabled" }}
                    />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      weeklyTargets?.find(
                        (o) => o.id === targetLog.weeklyTargetId,
                      )?.title || t("tabs.timeline.target-title-missing")
                    }
                    primaryTypographyProps={{
                      color: "text.disabled",
                      variant: "caption",
                    }}
                  />
                </ListItem>
              ))}
            </List>
          </Container>
        </Grid>
      </Grid>
    </StepContent>
  );
};

export default TimelineItemDetails;
